import { IconLabel } from '@salecycle/experimental/IconLabel';
import { Button, Icon } from '@salecycle/ui-component-library';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ISegment } from 'sections/offsite-campaigns/entities/offsiteCampaign';
import styled, { useTheme } from 'styled-components';
import { EmailTestingFilter } from '../../segment-item/segment-filter-items/TestingFilters/EmailTestingFilter';
import { SMSTestingFilter } from '../../segment-item/segment-filter-items/TestingFilters/SMSTestingFilter';
import { IntegrationChannel } from 'sections/client-management/ui/pages/client-settings/integrations/context/IntegrationsState';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.designToken.spacing3};
`;

const OptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.designToken.spacing2};
`;

export interface TestCampaignOptionsProps {
  segment: ISegment;
  onClick(channel: string): void;
}

export const TestCampaignOptions = ({ segment, onClick }: TestCampaignOptionsProps) => {
  const { t } = useTranslation('campaigns');
  const theme = useTheme();

  const emailFilter = useMemo(
    () =>
      segment?.segmentFilters?.find(filter => filter.type === 'testing' && filter.channel === IntegrationChannel.EMAIL),
    [segment?.segmentFilters],
  );

  const smsFilter = useMemo(
    () =>
      segment?.segmentFilters?.find(
        filter =>
          filter.type === 'testing' &&
          (filter.channel === IntegrationChannel.SMS || filter.channel === IntegrationChannel.WHATSAPP),
      ),
    [segment?.segmentFilters],
  );

  return (
    <Wrapper>
      <IconLabel
        icon="arrow-down"
        color={theme.designToken.neutral700}
        text={t('campaigns:offsiteEditor.segments.guides.whoIsTestVisitor')}
      ></IconLabel>
      <OptionsWrapper>
        {!!emailFilter ? (
          <EmailTestingFilter segmentFilter={emailFilter} segmentId={segment.id} />
        ) : (
          <Button
            title={t('campaigns:offsiteEditor.segments.filters.testing.button')}
            aria-label={t('campaigns:offsiteEditor.segments.filters.testing.button')}
            variation="secondary"
            leftSideIcon={<Icon icon="plus" />}
            onClick={() => onClick(IntegrationChannel.EMAIL)}
            id="add-email-address-for-testing"
          ></Button>
        )}
        {!!smsFilter ? (
          <SMSTestingFilter segmentFilter={smsFilter} segmentId={segment.id} />
        ) : (
          <Button
            title={t('campaigns:offsiteEditor.segments.filters.testing.smsButton')}
            aria-label={t('campaigns:offsiteEditor.segments.filters.testing.smsButton')}
            variation="secondary"
            leftSideIcon={<Icon icon="plus" />}
            onClick={() => onClick(IntegrationChannel.SMS)}
            id="add-mobile-number-for-testing"
          ></Button>
        )}
      </OptionsWrapper>
    </Wrapper>
  );
};
